import React, { useState, useEffect, useRef } from "react";
import { Typography, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import CloseIcon from "@material-ui/icons/Close";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import Moment from "moment";
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";
import { useHistory } from 'react-router-dom';

const CreateStockInward = (props) => {
    const classes = useStyles();
    const [Mode, setMode] = useState("");
    const [DocumentNo, setDocumentNo] = useState("");
    const [DocumentDate, setDocumentDate] = useState(Moment(new Date()).format("YYYY-MM-DD"));
    const [DocumentType, setDocumentType] = useState();
    const [ProductionSectionID, setProductionSectionID] = useState();
    const [TransactionStorecmb, setTransactionStorecmb] = useState();
    const [ProductionSectioncmb, setProductionSectioncmb] = useState();
    const [Remarks, setRemarks] = useState();
    const [AccountName, setAccountName] = useState({ id: props.AccountID, AccountName: props.AccountName });
    const [AccountID, setAccountID] = useState('');
    const [ACAccount, setACAccount] = useState([]);
    const [TransactionStoreID, setTransactionStoreID] = useState();
    const [FromStoreID, setFromStoreID] = useState();
    const [FromStorecmb, setFromStorecmb] = useState();
    const [responseGetData, fetchDataGetData] = UseFetchData();
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [response, fetchData] = UseFetchData();
    const { value, onChange, ...rest } = props;
    const [cursor, setCursor] = useState(null);
    const [disableStore, setdisableStore] = useState(false);
    const ref = useRef(null);
    const [Accountcmb, setAccountcmb] = useState([]);
    const history = useHistory();
    const [TransactionType, setTransactionType] = useState();


    const validationSchema = Yup.object({
        DocumentDate: Yup.string().required("Required!"),
        DocumentType: Yup.string().required("Required!"),
        TransactionType: Yup.string().required("Required!"),

    });



    useEffect(() => {
        const input = ref.current;
        if (input) input.setSelectionRange(cursor, cursor);
    }, [ref, cursor, value]);

    const handleChange = (e) => {
        onChange && onChange(e);
    };

    const onSubmit = (values) => {
        // setMode("Insert");
        // debugger;
        var UpdatedByID = sessionStorage.UID;
        var CreatedBYID = sessionStorage.UID;
        var bodyFormData = new FormData();
        bodyFormData.append("InventoryDocumentID", props.InventoryDocumentID);
        bodyFormData.append("DocumentNo", values.DocumentNo);
        bodyFormData.append("DocumentDate", values.DocumentDate);
        bodyFormData.append("DocumentType", values.DocumentType);
        bodyFormData.append("TransactionStoreID", values.TransactionStoreID);
        if (values.ProductionSectionID == "" || values.ProductionSectionID == undefined) {
            var PSID = "";
            bodyFormData.append("ProductionSectionID", PSID);
        } else {
            bodyFormData.append("ProductionSectionID", values.ProductionSectionID);
        }
        if (values.Remarks == "" || values.Remarks == undefined) {
            var PSID = "";
            bodyFormData.append("Remarks", Remarks);
        } else {
            bodyFormData.append("Remarks", values.Remarks);
        }
        //bodyFormData.append("Remarks", values.Remarks);
        if (values.AccountID == "" || values.AccountID == undefined) {
            var AID = "";
            bodyFormData.append("CustomerID", AID);
        } else {
            bodyFormData.append("CustomerID", values.AccountID);
        }
        if (values.FromStoreID == "" || values.FromStoreID == undefined) {
            var FSID = "";
            bodyFormData.append("FromStoreID", FSID);
        } else {
            bodyFormData.append("FromStoreID", values.FromStoreID);
        }
        bodyFormData.append("ModifiedByID", UpdatedByID);
        bodyFormData.append("CreatedBYID", CreatedBYID);
        bodyFormData.append("TransactionType", values.TransactionType);
        fetchData("StockInward/Save", bodyFormData);
    };

    const GetByIDData = () => {
        debugger;
        var bodyFormData = new FormData();
        bodyFormData.append("InventoryDocumentID", props.InventoryDocumentID);
        fetchDataGetData("StockInward/GetByID", bodyFormData);
    };


    const GetComboData = () => {
        fetchComboData("StockInward/ComboDataCreateSI");
    };

    const DocumentTypeOption = [
        { key: "Opening Stock", value: "Opening Stock" },
        { key: "Received From Production", value: "Received From Production" },
        { key: "Stock Transfer In", value: "Stock Transfer In" },
        { key: "Return From Customer", value: "Return From Customer" },
    ];

    const DocumentTypeData = () => {
        let DocumentType = DocumentTypeOption.map((data) => (
            <option key={data.key} value={data.value}>
                {data.key}
            </option>
        ));
        return DocumentType;
    };


    const TrasactionTypeOption = [
        //{ key: "Stock Transfer Out", value: "Stock Transfer Out" },
        { key: "Stock Transfer In", value: "Stock Transfer In" },
        { key: "Stock Adjustment", value: "Stock Adjustment" },
    ];

    const TrasactionTypeData = () => {
        let TrasactionType = TrasactionTypeOption.map((data) => (
            <option key={data.key} value={data.value}>
                {data.key}
            </option>
        ));
        return TrasactionType;
    };


    useEffect(() => {
        debugger;
        GetComboData();
        GetByIDData();
        if (sessionStorage.UserType == "Admin") {
            setdisableStore(false);
        } else {
            setTransactionStoreID(sessionStorage.StoreID === null ? "" : sessionStorage.StoreID);
            setdisableStore(true);
        }
    }, []);


    const ProductionSectionData = (options) => {
        if (options !== undefined) {
            let ProductionSec = options.map((data) => (
                <option key={data.ProductionSection} value={data.ProductionSectionID}>
                    {data.ProductionSection}
                </option>
            ));
            setProductionSectioncmb(ProductionSec);
        }
    };

    const FromStoreData = (options) => {
        if (options !== undefined) {
            let ToStore = options.map((data) => (
                <option key={data.StoreName} value={data.StoreID}>
                    {data.StoreName}
                </option>
            ));
            setFromStorecmb(ToStore);
        }
    };



    const StoreData = (options) => {
        if (options !== undefined) {
            let Store = options.map((data) => (
                <option key={data.StoreName} value={data.StoreID}>
                    {data.StoreName}
                </option>
            ));
            setTransactionStorecmb(Store);
        }
    };

    useEffect(() => {
        debugger;
        if (response.Response === true) {
            alert("Data Saved Succesfully.");
            props.PopulateData();
            props.setOpen(false);
            if (Mode === "Update") {

            } else {
                var InventoryDocumentID = response.ID;
                history.push('StockInwards/StockInwardView', { InventoryDocumentID }); // navigate to new route
            }
        }
        else if (response.Response === false) {
            if (response.Message.includes("Already") === true) {
                alert(response.Message);
            } else {
                alert("Failed.");
            }
        }
    }, [response]);

    useEffect(() => {
        debugger;
        if (ComboDataResponse !== undefined) {
            if (ComboDataResponse['CmbStore'] !== undefined && ComboDataResponse['CmbStore'].length > 0) {
                StoreData(ComboDataResponse["CmbStore"]);
            } else {
                StoreData([]);
                if (props.InventoryDocumentID !== "") {
                    setMode("Update");
                } else {
                    setMode("Insert");
                }
            }
            if (ComboDataResponse['CmbStore'] !== undefined && ComboDataResponse['CmbStore'].length > 0) {
                FromStoreData(ComboDataResponse["CmbStore"]);
            } else {
                FromStoreData([]);
                if (props.InventoryDocumentID !== "") {
                    setMode("Update");
                } else {
                    setMode("Insert");
                }
            }
            if (ComboDataResponse['cmbAccount'] !== undefined && ComboDataResponse['cmbAccount'].length > 0) {
                setACAccount(ComboDataResponse['cmbAccount']);
            } else {
                setACAccount([]);
                if (props.InventoryDocumentID !== "") {
                    setMode("Update");
                } else {
                    setMode("Insert");
                }
            }
            if (ComboDataResponse['CmbProductionSection'] !== undefined && ComboDataResponse['CmbProductionSection'].length > 0) {
                ProductionSectionData(ComboDataResponse["CmbProductionSection"]);
            } else {
                ProductionSectionData([]);
                if (props.InventoryDocumentID !== "") {
                    setMode("Update");
                } else {
                    setMode("Insert");
                }
            }
        }
    }, [ComboDataResponse]);


    useEffect(() => {
        debugger;
        if (responseGetData !== undefined && responseGetData.length > 0) {
            setDocumentNo(responseGetData[0].DocumentNo);
            setDocumentDate(responseGetData[0].DocumentDate === null ? "" : Moment(responseGetData[0].DocumentDate).format("YYYY-MM-DD"));
            setDocumentType(responseGetData[0].DocumentType === null ? "" : responseGetData[0].DocumentType);
            setTransactionStoreID(responseGetData[0].TransactionStoreID === null ? "" : responseGetData[0].TransactionStoreID);
            setProductionSectionID(responseGetData[0].ProductionSectionID === null ? "" : responseGetData[0].ProductionSectionID);
            setFromStoreID(responseGetData[0].FromStoreID === null ? "" : responseGetData[0].FromStoreID);
            setRemarks(responseGetData[0].Remarks === null ? "" || undefined : responseGetData[0].Remarks);
            setAccountID(responseGetData[0].CustomerID === null ? "" : responseGetData[0].CustomerID);
            setAccountName({ id: responseGetData[0].CustomerID, List: responseGetData[0].AccountName });
            setTransactionType(responseGetData[0].TransactionType === null ? "" : responseGetData[0].TransactionType);

        }
    }, [responseGetData]);

    const onAccountSelectChange = React.useCallback((e, ACData) => {
        setAccountID(ACData.id);
        setAccountName(ACData);
    }, []);






    const onSelectChange = (e) => {
        debugger;
        let targetvalue = e.target.value;
        let targetname = e.target.name;
        if (targetvalue !== "") {
            if (targetname === "AccountID") {
                setAccountID(targetvalue);
            }
            else if (targetname === "TransactionStoreID") {
                setTransactionStoreID(targetvalue);
            }
            if (targetname === "ProductionSectionID") {
                setProductionSectionID(targetvalue);
            }
            else if (targetname === "FromStoreID") {
                setFromStoreID(targetvalue);
            }
        }
        else {
            if (targetname === "AccountID") {
                setAccountID("");
            }
            else if (targetname === "TransactionStoreID") {
                setTransactionStoreID("");
            }
            if (targetname === "ProductionSectionID") {
                setProductionSectionID("");
            }
            else if (targetname === "FromStoreID") {
                setFromStoreID("");
            }
        }
    };

    let DocumentTypecmb = DocumentTypeData();
    let TransactionTypecmb = TrasactionTypeData();
    // let Customercmb = CustomerData();


    return (
        <div>
            <Formik
                initialValues={{
                    DocumentNo: DocumentNo,
                    DocumentDate: DocumentDate,
                    DocumentType: DocumentType,
                    TransactionStoreID: TransactionStoreID,
                    ProductionSectionID: ProductionSectionID,
                    AccountID: AccountID,
                    FromStoreID: FromStoreID,
                    Remarks: Remarks,
                    TransactionType: TransactionType,


                }}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
            >
                {(formik) => {
                    return (
                        <Form>
                            {/* <Typography className={classes.headertext} noWrap>
                                StockOutward Information
                            </Typography> */}
                            <Grid spacing={2} container direction="row">
                                <Grid item xs={3}>
                                    <label
                                        htmlFor={"DocumentNo"}
                                        style={{
                                            display: "block",
                                            width: "100%"
                                        }}
                                    >
                                        {"Document No"}
                                    </label>
                                </Grid>
                                <Grid item xs={3}>
                                    <BiztranControlsFormik
                                        control="input"
                                        type="text"
                                        name="DocumentNo"
                                        disabled={true}
                                        onChange={(e) => setDocumentNo(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={1.5}>
                                    <label
                                        htmlFor={"DocumentDate"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Document Date"}
                                    </label>
                                </Grid>
                                <Grid item xs={3}>
                                    <BiztranControlsFormik
                                        control="input"
                                        type="date"
                                        name="DocumentDate"
                                        disabled={true}
                                        onChange={(e) => setDocumentDate(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={3} >
                                    <label
                                        htmlFor={"DocumentType"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Document Type"}
                                    </label>
                                </Grid>
                                <Grid item xs={8}>
                                    <BiztranControlsFormik
                                        control="select"
                                        name="DocumentType"
                                        options={DocumentTypecmb}
                                        onChange={(e) => setDocumentType(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={3} >
                                    <label
                                        htmlFor={"TransactionType"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Transaction Type"}
                                    </label>
                                </Grid>
                                <Grid item xs={8}>
                                    <BiztranControlsFormik
                                        control="select"
                                        name="TransactionType"
                                        options={TransactionTypecmb}
                                        onChange={(e) => setTransactionType(e.target.value)}
                                    />
                                </Grid>
                                <Grid item xs={3} >
                                    <label
                                        htmlFor={"TransactionStoreID"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Transaction Store"}
                                    </label>
                                </Grid>
                                <Grid item xs={8}>
                                    <BiztranControlsFormik
                                        control="select"
                                        name="TransactionStoreID"
                                        options={TransactionStorecmb}
                                        onChange={onSelectChange}
                                        disabled={disableStore}
                                    />
                                </Grid>
                                {DocumentType === "Received From Production" ?
                                    <Grid item xs={3} >
                                        <label
                                            htmlFor={"ProductionSectionID"}
                                            style={{
                                                display: "block",
                                                width: "100%",
                                            }}
                                        >
                                            {"Production Section"}
                                        </label>
                                    </Grid> :
                                    null
                                }
                                {DocumentType === "Received From Production" ?
                                    <Grid item xs={8}>
                                        <BiztranControlsFormik
                                            control="select"
                                            name="ProductionSectionID"
                                            options={ProductionSectioncmb}
                                            onChange={onSelectChange}
                                        />
                                    </Grid> :
                                    null}
                                {/* <Grid item xs={3}>
                                    <label
                                        htmlFor={"CustomerID"}
                                        style={{
                                            display: "block",
                                            width: "100%",
                                        }}
                                    >
                                        {"Customer"}
                                    </label>
                                </Grid>
                                <Grid item xs={8}>
                                    <BiztranControlsFormik
                                        control="select"
                                        name="CustomerID"
                                        options={Customercmb}
                                        onChange={onSelectChange}
                                    />
                                </Grid> */}
                                {DocumentType === "Return From Customer" ?
                                    <Grid item xs={3}>
                                        <label htmlFor={"AccountID"}
                                            style={{
                                                display: 'block',
                                                width: '100%',
                                            }}>
                                            {"Customer"}
                                        </label>
                                    </Grid> : null}
                                {DocumentType === "Return From Customer" ?
                                    <Grid item xs={8}>
                                        <BiztranControls.Autocomplete
                                            options={ACAccount}
                                            onChange={onAccountSelectChange}
                                            value={AccountName}
                                            name="AccountID"
                                        />
                                    </Grid> : null}

                                {DocumentType === "Stock Transfer In" ?
                                    <Grid item xs={3} >
                                        <label
                                            htmlFor={"FromStoreID"}
                                            style={{
                                                display: "block",
                                                width: "100%",
                                            }}
                                        >
                                            {"From Store"}
                                        </label>
                                    </Grid> :
                                    null
                                }
                                {DocumentType === "Stock Transfer In" ?
                                    <Grid item xs={8}>
                                        <BiztranControlsFormik
                                            control="select"
                                            options={FromStorecmb}
                                            name="FromStoreID"
                                            onChange={onSelectChange}
                                        />
                                    </Grid> :
                                    null}
                                <Grid item xs={3}>
                                    <label
                                        htmlFor={"Remarks"}
                                        style={{
                                            display: "block",
                                            width: "100%"
                                        }}
                                    >
                                        {"Remarks"}
                                    </label>
                                </Grid>
                                <Grid item xs={8}>
                                    <BiztranControlsFormik
                                        control="input"
                                        type="text"
                                        ref={ref}
                                        value={Remarks}
                                        name="Remarks"
                                        onChange={(e) => {
                                            setRemarks(e.target.value)
                                            handleChange()
                                        }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid spacing={2} container direction="row">

                                <Grid item xs={12}>
                                    <div style={{ width: "100%" }}>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                alignContent: "center",
                                            }}
                                        >
                                            <BiztranControls.Button
                                                text="SAVE"
                                                type="submit"
                                                // disabled={DisableSaveBtn}
                                                startIcon={<SaveIcon />}
                                            />
                                            <BiztranControls.Button
                                                text="CLOSE"
                                                startIcon={<CloseIcon />}
                                                onClick={() => {
                                                    props.setOpen(false);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </div>
    );
};

const useStyles = makeStyles((theme) => ({
    headertext: {
        background: "#e6d8d8", //theme.palette.tertiary.gradient,
        color: "#3d3d3d",
        height: "2rem",
        paddingLeft: "30px",
        fontSize: "1.5rem",
        //marginTop: "-16px",
        marginBottom: "10px",
        marginLeft: "-24px",
        marginRight: "-24px",
        //   borderRadius: "1rem",
    },
}));

export default CreateStockInward;
